import { Button, Modal, Form, Row, Col, Input, Select, message } from "antd";
import { useEffect } from "react";
import postDataArps from "../../../../services/postDataArps";

export default function UpdateBudget({
  isVisible,
  selected,
  setVisible,
  refetch,
}: any) {

  const year = new Date().getFullYear();

  const [form] = Form.useForm();

  const onSubmit = async () => {
    const { opex_amount, capex_amount } = await form.validateFields();

    const data = {
      opex_amount: Number(opex_amount),
      capex_amount: Number(capex_amount),
      total_amount: Number(opex_amount) + Number(capex_amount),
    };


    const uri = `finance/budget/${selected?._id}`;

    const response = await postDataArps(data, uri);

    if (response.success) {
      message.success("Updated successfully");
      refetch();
    }
    setVisible(!isVisible);
  };

  const clearForm = async () => {
    form.resetFields();
  };

  const defaultValues = {
    opex_amount: Number(selected?.opex_amount),
    capex_amount: Number(selected?.capex_amount),
  };

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(defaultValues);
  }, [form, defaultValues]);

  return (
    <Modal
      visible={isVisible}
      title={`${selected?.center?.name} Budget : ${year}`}
      onCancel={() => setVisible(!isVisible)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="updateBudget"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          danger
        >
          Update
        </Button>,
      ]}
    >
      <Form
        id="updateBudget"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
        initialValues={defaultValues}
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="opex_amount"
              label="Operational Budget"
              // initialValue={Number(selected?.opex_amount)}
              rules={[
                {
                  required: false,
                  message: "Please enter operational budget",
                },
              ]}
            >
              <Input type={"number"} placeholder="Opex Budget" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="capex_amount"
              label="Capital Budget"
              // initialValue={Number(selected?.capex_amount)}
              rules={[
                {
                  required: false,
                  message: "Please enter capital budget",
                },
              ]}
            >
              <Input type={"number"} placeholder="Capex Budget" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
